import s from './Breadcrumb.module.scss';

const Breadcrumb = ({ items }) => {
  return (
    <div className={s.breadcrumb}>
      <ol className={s.breadcrumbList} itemscope itemtype="http://schema.org/BreadcrumbList">
        {items.map((item, index) => (
          <li className={s.breadcrumbItem} itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" key={index}>
            {item.link ? (
              <a itemprop="item" href={item.link}>
                <span itemprop="name">{item.name}</span>
              </a>
            ) : (
              <span itemprop="name">{item.name}</span>
            )}
            <meta itemprop="position" content={index + 1} />
          </li>
        ))}
      </ol>
    </div>
  );
};

export default Breadcrumb;
